import { render, staticRenderFns } from "./AuctionPage.vue?vue&type=template&id=c3cf186c&scoped=true"
import script from "./AuctionPage.vue?vue&type=script&lang=js"
export * from "./AuctionPage.vue?vue&type=script&lang=js"
import style0 from "./AuctionPage.vue?vue&type=style&index=0&id=c3cf186c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cf186c",
  null
  
)

export default component.exports